import { ProductSlugs } from '@deque/billing-utils';
import { useAuthContext } from '~/common/contexts/auth';
import { useEnterprises } from '~/common/contexts/enterprises';
import { useFeatureFlagState } from '~/common/contexts/featureFlags';
import { getViewerProductAccess } from '~/common/utils/subscriptions';
import { canAccessTeams } from '../utils/can-access-teams';

const useCanAccessTeams = (): boolean => {
  const { activeEnterprise, isAdmin: isEnterpriseAdmin } = useEnterprises();
  const { billingUser } = useAuthContext();
  const teamsV1 = useFeatureFlagState('teams_v1');
  const teamsV2 = useFeatureFlagState('teams_v2');
  const reportsTeamsV1 = useFeatureFlagState('axe_reports_teams_v1');

  if (!billingUser) {
    return false;
  }

  const subscriptions =
    activeEnterprise?.subscriptions ?? billingUser.subscriptions;
  const monitorAccess = getViewerProductAccess(
    billingUser,
    activeEnterprise,
    isEnterpriseAdmin
  )[ProductSlugs.axeMonitor];

  return canAccessTeams({
    isEnterpriseAdmin,
    subscriptions,
    monitorAccess,
    flags: { teamsV1, teamsV2, reportsTeamsV1 }
  });
};

export default useCanAccessTeams;
